import React from 'react';

import { useTranslation } from 'react-i18next';

import Background from 'components/settings/projectConfiguration/branding/svgs/downloadLanding/branding-download-bg.svg';
import DownloadButton from 'components/settings/projectConfiguration/branding/svgs/downloadLanding/branding-download-buttonbg.svg';
import ButtonText from 'components/settings/projectConfiguration/branding/svgs/downloadLanding/branding-download-buttontext.svg';
import Content from 'components/settings/projectConfiguration/branding/svgs/downloadLanding/branding-download-content.svg';
import Links from 'components/settings/projectConfiguration/branding/svgs/downloadLanding/branding-download-links.svg';
import Logo from 'components/settings/projectConfiguration/branding/svgs/downloadLanding/branding-download-logo.svg';
import Powered from 'components/settings/projectConfiguration/branding/svgs/downloadLanding/branding-download-powered.svg';

export default function DownloadLandingPreview({
  buttonBgColour,
  buttonTextColour,
  handshqLabel,
  logoSrc,
  primaryBgColour,
  textLinkColour,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'settings.projectConfiguration.branding.DownloadLandingPreview',
  });

  // pending: placeholder until decision made on scaling behaviour
  const imageContainerStyles = {
    left: '233px',
    height: '58px',
    top: '112px',
    bottom: '0px',
    width: '116px',
    position: 'relative',
  };

  return (
    <div
      className='svg-preview__document tw-bg-white'
      style={{ height: '304px', width: '413px' }}
    >
      <Background fill={primaryBgColour} />
      {handshqLabel && <Powered />}
      <Content />
      <DownloadButton fill={buttonBgColour} />
      <ButtonText fill={buttonTextColour} />
      <Logo fill={primaryBgColour} />
      <Links fill={textLinkColour} />
      {logoSrc && (
        <div style={imageContainerStyles}>
          <img
            alt={i18nT('imageAlt')}
            className='image--bound-scaling'
            src={logoSrc}
          />
        </div>
      )}
    </div>
  );
}
